var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-tree-group"},[_c('ul',{staticClass:"nav-tree"},_vm._l((_vm.treeData),function(item,index){return _c('li',{key:index,staticClass:"nav-tree-item"},[_c('TreeNavItem',{attrs:{"treeData":item},on:{"holdClick":_vm.holdClick}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }